import { rmChars } from './../../ProjectNonSpecificComponents/Functions/rmChars';
const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export const convertToReadableBytes = (value: number | string) => {
    if(!value || (typeof value === "number" && value < 0)) return
    let _value = value.toString()
    _value = rmChars(_value)
    let index = 0
    let result = parseInt(_value, 10) || 0;
    
    while(result >= 1024 && ++index){
        result = result/1024;
    }
    return(result.toFixed(result < 10 && index > 0 ? 1 : 0) + ' ' + units[index]);
}
